import { render, staticRenderFns } from "./BioComputeObjectExportCard.vue?vue&type=template&id=75c76e40&"
import script from "./BioComputeObjectExportCard.vue?vue&type=script&lang=js&"
export * from "./BioComputeObjectExportCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports